module.exports = __webpack_public_path__ + "img/6.86db9c39.png";